<template>
    <div :class="['page about',{ off: !pageOn }]">
        <VHeader type="back" @back="pageOn = false;" />
        <div class="page-content" :style="{ backgroundColor: backgroundColor, color: fontColor }">
            <div style="position: relative;">
                <p style="text-align: center;margin:20px 0px 20px 0px;font-size: 28px;">MEMBER DETAILS</p>
                <p style="margin:20px 0px 3px 40px;font-size: 16px;">Name</p>
                <input class="i-name" placeholder="Your Name" v-model="name" style="width:calc(100% - 80px);margin:0px 0px 0px 30px;padding:10px 10px;border-radius: 10px;" />
                <p style="margin:20px 0px 3px 40px;font-size: 16px;">Mobile</p>
                <input placeholder="Mobile Number" v-model="mobile" style="width:calc(100% - 80px);margin:0px 0px 0px 30px;padding:10px 10px;border-radius: 10px;" />
                <p style="margin:20px 0px 3px 40px;font-size: 16px;">Email</p>
                <input placeholder="Email Address" v-model="email" style="width:calc(100% - 80px);margin:0px 0px 0px 30px;padding:10px 10px;border-radius: 10px;" />
                <div class="label">
                    <input type="checkbox" v-model="sendSMS" style="margin:0px 20px 20px 30px;border-radius:10px;float:left" />
                    <p style="margin:20px 30px 20px 40px;font-size: 16px;line-height: 40px;">Subscribe to Text Offers</p>
                </div>
                <div class="label">
                    <input type="checkbox" v-model="sendEMAIL" style="margin:0px 20px 20px 30px;border-radius:10px;float:left" />
                    <p style="margin:20px 30px 20px 40px;font-size: 16px;line-height: 40px;">Subscribe to Email Offers</p>
                </div>
                <p class="btn" @click="save" :style="{ backgroundColor: btnColor, color: btnFontColor }">SAVE</p>
                <p @click="closeAccount" style="text-align:center;font-size: 17px;margin-top:30px;text-decoration: underline;">Close my account</p>
            </div>
        </div>  
    </div>
   
</template>

<script>

import VHeader from '@/components/VHeader.vue'
import { pageOn } from '@/utils/pageOn.js'
import { mapActions, mapMutations, mapState } from 'vuex';
import Alert from '@/utils/Alert.js';
import WebSoc from '@/utils/WebSoc.js'

export default {
    name: 'edit-copper',
    mixins: [ pageOn ],
    components: {
        VHeader
    },
    computed: {
        client_id () { return this.$store.state.client_id },
        customer_id () { return this.$store.state._id },
        customerID () { return this.$store.state.id },
        current () {  
            var state = this.$store.state
            return {
                name: state.name,
                email: state.email,
                phone: state.phone,
                _id: state.auth._id,
                sendEMAIL: state.sendEMAIL === false ? false : true,
                sendSMS: state.sendSMS === false ? false : true
            }
        },
        backgroundColor () { return this.$store.state.backgroundColor },
        fontColor () { return this.$store.state.fontColor },
        btnColor () { return this.$store.state.btnColor },
        btnFontColor () { return this.$store.state.btnFontColor },            
    },
    data () {
        return {
            name: '',
            email: '',
            mobile: '',
            sendSMS: true,
            sendEMAIL: true,
            _id: ''
        }
    },
    mounted () {
        var current = this.current;
        if ( current ) {
            this.name = current.name;
            this.email = current.email;
            this.mobile = current.phone;
            this.sendSMS = current.sendSMS;
            this.sendEMAIL = current.sendEMAIL === false ? false : true;
            this._id = current._id;
        }
        console.log('this.current',JSON.parse(JSON.stringify(this.current)));
    },
    methods: {
        closeAccount () {
            Alert.yesno('Do you really want to close your account?<br>This cannot be undone.',yes => {
                if ( !yes ) return;
                var { client_id, customerID, customer_id } = this;
                WebSoc.SEND({ t: 'closeAccount', data: { client_id, customer_id, customerID }},resp => {
                    console.log('closeAccount resp',resp);
                    resp.error && Alert.message(resp.error);
                    resp.success && this.clearAuth();
                    resp.success && Alert.message('Your Account has been closed');
                })
            })
        },
        save () {
            console.log('save this.sendSMS',this.sendSMS);
            if ( !this.mobile || isNaN(this.mobile) ) return Alert.message('Please provide a valid mobile number');
            this.pageOn = false;
            return this.$emit('updateMember',{
                name: this.name,
                phone: this.mobile,
                email: this.email,
                sendSMS: this.sendSMS,
                sendEMAIL: this.sendEMAIL
            });
        },
        ...mapMutations([
            'popPage',
            'pushPage',
            'setValue',
            'setPages',
            'clearAuth'
        ])
    },

    
}

</script>

<style lang="scss">
.copper {
    background-color: #114456 !important;
}
input[type="checkbox"] { background-color: white; width: 40px; height: 40px; border: 1px solid; -webkit-appearance: none; appearance: none; }
input[type="checkbox"]:checked { 
    background-size: contain;
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAQAAAD9CzEMAAAAg0lEQVR4Ae3QvQ2CMRRD0dtRMk74W4zOa7HBNw6EAYKQqHgSDTFC4Js6x9IjpZQ+3YGjl78ykJe/P3n5MhB+H/53+f61/JoTzckvDM40D79ieXy90Dy3F+PFxO5Nvkxs5vN1YjZfJrbz+Toxly8T3cA/TVj4OiEMycSXCWFMiL8upXQDujO26ouV5ZIAAAAASUVORK5CYII=);
}
</style>